import { TimeTrack } from '../types/time-tracking';

/**
 * Returns the UTC calendar day (YYYY-MM-DD) of a wall-clock ISO timestamp.
 *
 * Worklog timestamps are wall-clock values suffixed with `Z` and must be grouped
 * by the literal date they carry, NOT by the user's local calendar day — otherwise
 * an entry like "2026-06-15T11:49Z" could land in the wrong day group for viewers
 * far from UTC, diverging from the literal date shown on the entry row.
 */
const getUtcCalendarDay = (isoDate: string): string => isoDate.slice(0, 10);

/**
 * Groups a flat list of time tracks by UTC calendar day, keyed by the ISO string
 * of the first track encountered for that day. Keys are kept stable (the first
 * track's `date` wins) so consumers can deterministically render groups.
 */
export const groupTracksByDate = (tracks: TimeTrack[]): Record<string, TimeTrack[]> =>
  tracks.reduce(
    (acc, track) => {
      const trackDay = getUtcCalendarDay(track.date);
      const existingKey = Object.keys(acc).find(d => getUtcCalendarDay(d) === trackDay);
      const key = existingKey ?? track.date;
      acc[key] = [...(acc[key] ?? []), track];
      return acc;
    },
    {} as Record<string, TimeTrack[]>
  );
